
import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  imports: [RouterOutlet]
})

export class AppComponent {

  constructor(private meta: Meta) { }

  ngOnInit() {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const src = scripts[i].src;
      let versionRegex = /main\.([a-zA-Z0-9]+)\.bundle\.js/gi;
      let cacheVersion = versionRegex.exec(src);
      if (cacheVersion) {
        const versionSize = 5;
        const version = cacheVersion[1].substring(cacheVersion[1].length - versionSize, versionSize);
        this.meta.addTag({ name: 'version-cache', content: version });
      }
    }
  }
}

